import { Component } from '@angular/core';
import { AuthUser, AuthUser_Document } from '../../model/auth-user';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { DataService } from 'projects/Shared-Lib/services/data.service';
import { AppService } from '../../services/app.service';
import { FilterDataService } from '../../services/filter-data.service';

@Component({
  selector: 'app-auth-user-edit',
  templateUrl: './auth-user-edit.component.html',
  styleUrls: ['./auth-user-edit.component.css']
})
export class AuthUserEditComponent {
  ControllerName = 'AuthUser';
  Title: string;
  IsNew: boolean;
  Doc: AuthUser_Document;
  UserID: string;
  
  constructor(private route: ActivatedRoute, private dlgService: DialogService,
                private appService: AppService, private filterService: FilterDataService,
                private router: Router, private dataService: DataService) {

    this.Doc = new AuthUser_Document(dlgService, router, dataService);
    this.Doc.SelectEnabled = 1;
    this.Doc.UserType = 1;
  }

  ngOnInit() {
    this.UserID = this.route.snapshot.paramMap.get('id');

    if (this.UserID) {
      //edit mode
      this.Doc.GetDocument(this.UserID);
      this.IsNew = false;
      this.Title = "Edit";
    }
    else {
      //create mode
      this.IsNew = true;
      this.Title = "Create";
    }
  }

  isValid(){
    if (this.Doc.UserAccount && this.Doc.UserAccount !== ''
        && this.Doc.UserName && this.Doc.UserName !== ''
        && this.Doc.EMail && this.Doc.EMail !== ''){
      return false;
    }

    return true;
  }

  Submit(){
    let postData: AuthUser = new AuthUser();
    this.Doc.IsEnabled = this.Doc.SelectEnabled === 1;
    postData.SetData(this.Doc);
    if(this.IsNew) {
      this.dataService.addData(this.ControllerName, postData, (ret) => {
          let result = this.dlgService.CreateSubmit();
          result.then((ret) => {
            if (ret === 'Back') {
              this.Cancel();
            } 
            else if(ret === 'Create Another') {
              this.Doc.UserID = '00000000-0000-0000-0000-000000000000';
              this.Doc.UserAccount = '';
              this.Doc.UserName = '';
              this.Doc.EMail = '';
              this.Doc.UserType = 1;
              this.Doc.SelectEnabled = 1;
            }
          }).catch((error) => {
            console.error(error);
          });
      }, (err) =>{
        let result = this.dlgService.ErrorInformation(err.Message);
        result.then((ret) => {
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  Cancel(){
    let lastPageInfo = this.filterService.GetSearchInfo();
    if (lastPageInfo.RouteName) {
      this.router.navigate([lastPageInfo.RouteName]);
    }
    else
      this.router.navigate(['/Auth/AuthUser']);
  }
}
